import React from 'react';
export const BountiesPage = () => {
  return <main className="flex-grow container mx-auto px-4 py-6 lg:px-6" data-id="element-351">
      <div className="text-center py-16" data-id="element-352">
        <h1 className="text-3xl font-bold mb-4" data-id="element-353">Bounties Coming Soon</h1>
        <p className="text-gray-600 max-w-lg mx-auto" data-id="element-354">
          Our bounties feature is currently under development. Soon you'll be
          able to create and fulfill bounties for news, research, and
          information.
        </p>
      </div>
    </main>;
};